module.exports = __webpack_public_path__ + "static/media/SIH.fd16ca8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/SIH.jpg
// module id = 73
// module chunks = 0